export default "__VITE_ASSET__C5Ze9OwJ__"